const control = {
    position: 'absolute',
    top: '50%',
    height: 52,
    marginTop: -30,
    cursor: 'pointer'
}

export default {
    leftControl: {
        ...control,
        left: 0,
        marginLeft: -11
    },
    rightControl: {
        ...control,
        right: 0,
        marginRight: -11
    }
}



// WEBPACK FOOTER //
// ./src/components/Slideshow/Control/styles.js